<template>
  <div>
    <corporate-header />
    <employer-search-hero ref="employerSearchHero" />
    <premium-benefits-section />
    <trust-and-safety-section />
    <bright-horizons-section />
    <premium-signup-cta @sign-up-click="$refs.employerSearchHero.signUpClick()" />
  </div>
</template>

<script lang="ts">
import EmployerSearchHero from './EmployerSearchHero.vue';
import PremiumBenefitsSection from '../components/PremiumBenefitsSection.vue';
import CorporateHeader from '../components/CorporateHeader.vue';
import TrustAndSafetySection from './TrustAndSafetySection.vue';
import PremiumSignupCta from './PremiumSignupCta.vue';
import BrightHorizonsSection from './BrightHorizonsSection.vue';

export default {
  name: 'BhBenefitsLanding',
  components: {
    EmployerSearchHero,
    PremiumBenefitsSection,
    CorporateHeader,
    TrustAndSafetySection,
    PremiumSignupCta,
    BrightHorizonsSection,
  },
};
</script>
